import { z } from "zod";

const GrantRoleSchema = z.enum(["viewer", "editor"]);

const optionalText = z.string().nullish().transform((value) => value ?? undefined);

export const ShareUserSchema = z.object({
  userId: z.string(),
  firstName: optionalText,
  lastName: optionalText,
  email: optionalText,
  role: GrantRoleSchema.optional(),
});

export const OrgUserStatusSchema = z.enum(["active", "blocked"]);

export const ShareUsersSchema = z
  .array(ShareUserSchema.extend({ status: OrgUserStatusSchema }))
  .transform((users) => users.filter((user) => user.status === "active"));

export const ResourceSharesSchema = z.object({
  owner: ShareUserSchema.nullable(),
  grants: z.array(z.object({
    id: z.string(),
    granteeUserId: z.string(),
    user: ShareUserSchema.nullable(),
  })),
  teamGrants: z.array(z.object({
    id: z.string(),
    granteeTeamId: z.string(),
    team: z.object({ name: z.string(), memberCount: z.number() }).nullable(),
    role: GrantRoleSchema,
  })),
});

export const ShareableTeamsPageSchema = z.object({
  teams: z.array(z.object({
    id: z.string(),
    name: z.string(),
    memberCount: z.number(),
    canShareTo: z.boolean(),
  })),
  total: z.number(),
});

export const CreatedShareGrantSchema = z.object({ id: z.string() });

export type ShareableTeamsPage = z.infer<typeof ShareableTeamsPageSchema>;
